import { useState } from 'react';
import {
  IconButton,
  Stepper,
  Step,
  StepButton,
  StepLabel,
} from '@mui/material';
import CircleIcon from '@mui/icons-material/Brightness1';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import { filterUndefined } from '../../utils/FilterUndefinedObject';
import './VerticalStepper.scss';

/**
 * Progress through numbered steps with vertical orientation
 *
 * @param {*} props
 * steps - steps {
 *  stepLabel: Step label,
 *  component: Component to display on the step,
 * }
 * activeStep - the current active step (step index)
 */
const defaultProps = {
  steps: [],
  activeStep: null,
  handleStep: null,
  nonLinear: false,
  className: '',
  stepperClassName: '',
};
export default function VerticalStepper(props) {
  const {
    steps,
    activeStep,
    handleStep,
    nonLinear,
    className,
    stepperClassName,
    ...others
  } = { ...defaultProps, ...filterUndefined(props) };
  const [open, setOpen] = useState(true);

  const handleOnClick = () => {
    setOpen(!open);
  };

  const displayTextOrIcon = (index, step) => {
    if (open) {
      return (
        <StepButton
          icon={<CircleIcon className={`vertical-step-icon ${index === activeStep ? 'vertical-step-selected-icon' : ''}`} />}
          onClick={handleStep(index)}
          className={`vizzle-stepper-${index}`}
        >
          <div className='vertical-step-stepper-label'>{step.stepLabel}</div>
        </StepButton>
      );
    }
    return (
      <StepButton
        onClick={handleStep(index)}
        icon=''
        className={`vertical-stepper-icon ${index === activeStep ? 'vertical-icon-step-selected' : ''} vizzle-collapsed-icon-stepper-${index}`}
      >
        {step.icon}
      </StepButton>
    );
  };

  return (
    <div className={`vertical-step-container ${className} ${open ? '' : 'vertical-step-container-collapsed'}`} {...others}>
      <div className={`vertical-step-stepper-container ${stepperClassName}`}>
        {open ? (
          <IconButton
            className='vertical-step-collapse-action'
            onClick={handleOnClick}
            tabIndex={0}
            aria-label='Collapse Stepper'
          >
            <NavigateBeforeIcon className='vertical-step-collapse-icon' />
          </IconButton>
        ) : (
          <IconButton
            className='vertical-step-collapse-action'
            onClick={handleOnClick}
            tabIndex={0}
            aria-label='Expand Stepper'
          >
            <NavigateNextIcon className='vertical-step-collapse-icon' />
          </IconButton>
        )}

        <div className='stepper-inner'>
          <Stepper
            activeStep={activeStep}
            nonLinear={nonLinear}
            orientation='vertical'
            className='vertical-step-stepper'
          >
            {steps.map((step, index) => (
              <Step key={step.stepLabel} data-test={`vertical-step-stepper-${index}`}>

                {handleStep && activeStep != null
                  ? displayTextOrIcon(index, step)
                  : (
                    <StepLabel
                      icon={<CircleIcon className={`vertical-step-icon ${index === activeStep ? 'vertical-step-selected-icon' : ''}`} />}
                      className={`vizzle-stepper-${index}`}
                    >
                      <div className='vertical-step-stepper-label'>{step.stepLabel}</div>
                    </StepLabel>
                  )}

              </Step>
            ))}
          </Stepper>
        </div>

      </div>
      <div className='vertical-step-content'>
        {activeStep === null
          ? ''
          : steps[activeStep].component}
      </div>
    </div>
  );
}
